export interface ContestFeesGetResultAjax {
  readonly [index: string]: ContestFeesGetResult;
}

export enum ContestExtendLength {
  EXTEND_3_DAYS = '3',
  EXTEND_5_DAYS = '5',
  EXTEND_7_DAYS = '7',
  EXTEND_14_DAYS = '14',
  EXTEND_21_DAYS = '21',
}

export type ContestExtendFees = {
  readonly [key in ContestExtendLength]: number
};

export interface ContestFeesGetResult {
  readonly currencyId: number;
  readonly contestId?: number;
  readonly featuredPrice: number;
  readonly topContestPrice: number;
  readonly highlightPrice: number;
  readonly sealedPrice: number;
  readonly ndaPrice: number;
  readonly privatePrice: number;
  readonly urgentPrice: number;
  readonly extendedPrice?: ContestExtendFees;
}
